// src/pages/Admins.js
import { useEffect, useState } from 'react';
import { collection, onSnapshot, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../context/AuthContext';
import { PageHeader, Card, Badge, Btn, Table, TD, SearchBar, FilterSelect, ConfirmModal } from '../components/UI';

export default function Admins() {
  const { admin: me } = useAuth();
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');
  const [confirm, setConfirm] = useState(null);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'admins'), snap => {
      setAdmins(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
    return unsub;
  }, []);

  const updateStatus = async (id, status) => {
    await updateDoc(doc(db, 'admins', id), { status });
    setConfirm(null);
  };

  const filtered = admins.filter(a => {
    const q = search.toLowerCase();
    const matchQ = !q || a.name?.toLowerCase().includes(q) || a.email?.toLowerCase().includes(q);
    const matchF = filter === 'all' || a.status === filter;
    return matchQ && matchF;
  });

  const rows = filtered.map(a => [
    <TD key="name"><div style={{ fontWeight: 600 }}>{a.name}</div></TD>,
    <TD key="email" mono>{a.email}</TD>,
    <TD key="status"><Badge status={a.status} /></TD>,
    <TD key="date">{a.createdAt?.toDate?.()?.toLocaleDateString('bn-BD') || '—'}</TD>,
    <TD key="act">
      {a.id !== me?.uid && (
        <div style={{ display: 'flex', gap: 6 }}>
          {a.status !== 'approved' && (
            <Btn variant="success" onClick={() => setConfirm({ id: a.id, status: 'approved', name: a.name, action: 'approve' })}>✓ Approve</Btn>
          )}
          {a.status !== 'blocked' && (
            <Btn variant="danger" onClick={() => setConfirm({ id: a.id, status: 'blocked', name: a.name, action: 'block' })}>⊘ Block</Btn>
          )}
          {a.status === 'blocked' && (
            <Btn variant="ghost" onClick={() => setConfirm({ id: a.id, status: 'pending', name: a.name, action: 'unblock' })}>↩ Unblock</Btn>
          )}
        </div>
      )}
      {a.id === me?.uid && <span style={{ color: '#646970', fontSize: 12 }}>আপনি</span>}
    </TD>,
  ]);

  const counts = { all: admins.length, pending: admins.filter(a => a.status === 'pending').length, approved: admins.filter(a => a.status === 'approved').length, blocked: admins.filter(a => a.status === 'blocked').length };

  return (
    <div>
      <PageHeader title="🔑 Admin Management" sub={`মোট ${admins.length} জন admin`} />

      {/* Count badges */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
        {[['all','সকল'],['pending','Pending'],['approved','Approved'],['blocked','Blocked']].map(([v,l]) => (
          <button key={v} onClick={() => setFilter(v)} style={{
            padding: '4px 14px', borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: 'pointer',
            background: filter === v ? '#2271b1' : '#2a2a2a',
            color: filter === v ? '#fff' : '#a7aaad',
            border: filter === v ? '1px solid #2271b1' : '1px solid #3a3a3a',
          }}>{l} ({counts[v]})</button>
        ))}
      </div>

      <Card>
        <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
          <SearchBar value={search} onChange={setSearch} placeholder="নাম বা email খুঁজুন..." />
          <FilterSelect value={filter} onChange={setFilter} options={[['all','সকল Status'],['pending','Pending'],['approved','Approved'],['blocked','Blocked']]} />
        </div>
        <Table
          cols={['নাম', 'Email', 'Status', 'তারিখ', 'Action']}
          rows={rows}
          loading={loading}
        />
      </Card>

      <ConfirmModal
        open={!!confirm}
        title={confirm?.action === 'block' ? '⊘ Block করবেন?' : confirm?.action === 'approve' ? '✓ Approve করবেন?' : '↩ Unblock করবেন?'}
        msg={`"${confirm?.name}" কে ${confirm?.action === 'block' ? 'block' : confirm?.action === 'approve' ? 'approve' : 'unblock'} করতে চান?`}
        onConfirm={() => updateStatus(confirm.id, confirm.status)}
        onCancel={() => setConfirm(null)}
        danger={confirm?.action === 'block'}
      />
    </div>
  );
}
